require("core-js/modules/es.array.reduce");

(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports,
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 3);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 1 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__); // extracted by mini-css-extract-plugin

  /* harmony default export */


  __webpack_exports__["default"] = {
    "grid": "grid__2X0_t",
    "grid-flush": "grid-flush__1oUUI",
    "gridFlush": "grid-flush__1oUUI",
    "grid-fluid": "grid-fluid__1--av",
    "gridFluid": "grid-fluid__1--av",
    "row": "row__Sb6ER",
    "row-no-gutters": "row-no-gutters__cdlxq",
    "rowNoGutters": "row-no-gutters__cdlxq",
    "col": "col__2Nsmq",
    "row-direction-row": "row-direction-row__2JU3Y",
    "rowDirectionRow": "row-direction-row__2JU3Y",
    "row-direction-column": "row-direction-column__2ZtEX",
    "rowDirectionColumn": "row-direction-column__2ZtEX",
    "row-between": "row-between__RDaVZ",
    "rowBetween": "row-between__RDaVZ",
    "row-around": "row-around__3_iXA",
    "rowAround": "row-around__3_iXA",
    "row-start": "row-start__KEuhj",
    "rowStart": "row-start__KEuhj",
    "row-center": "row-center__3fAul",
    "rowCenter": "row-center__3fAul",
    "row-text-center": "row-text-center__2si6C",
    "rowTextCenter": "row-text-center__2si6C",
    "row-end": "row-end__1aI6m",
    "rowEnd": "row-end__1aI6m",
    "row-top": "row-top__1jSVg",
    "rowTop": "row-top__1jSVg",
    "row-middle": "row-middle__UikoE",
    "rowMiddle": "row-middle__UikoE",
    "row-bottom": "row-bottom__1W8wC",
    "rowBottom": "row-bottom__1W8wC",
    "row-stretch": "row-stretch__twnTG",
    "rowStretch": "row-stretch__twnTG",
    "row-direction-row-sm": "row-direction-row-sm__XyJKF",
    "rowDirectionRowSm": "row-direction-row-sm__XyJKF",
    "row-direction-column-sm": "row-direction-column-sm__32rW-",
    "rowDirectionColumnSm": "row-direction-column-sm__32rW-",
    "row-between-sm": "row-between-sm__1IP_r",
    "rowBetweenSm": "row-between-sm__1IP_r",
    "row-around-sm": "row-around-sm__1kIBK",
    "rowAroundSm": "row-around-sm__1kIBK",
    "row-start-sm": "row-start-sm__1EjTA",
    "rowStartSm": "row-start-sm__1EjTA",
    "row-center-sm": "row-center-sm__1y6zL",
    "rowCenterSm": "row-center-sm__1y6zL",
    "row-text-center-sm": "row-text-center-sm__10GjO",
    "rowTextCenterSm": "row-text-center-sm__10GjO",
    "row-end-sm": "row-end-sm__2gYte",
    "rowEndSm": "row-end-sm__2gYte",
    "row-top-sm": "row-top-sm__OXk2I",
    "rowTopSm": "row-top-sm__OXk2I",
    "row-middle-sm": "row-middle-sm__2G35p",
    "rowMiddleSm": "row-middle-sm__2G35p",
    "row-bottom-sm": "row-bottom-sm__160mg",
    "rowBottomSm": "row-bottom-sm__160mg",
    "row-stretch-sm": "row-stretch-sm__1UkJa",
    "rowStretchSm": "row-stretch-sm__1UkJa",
    "row-direction-row-md": "row-direction-row-md__26IPW",
    "rowDirectionRowMd": "row-direction-row-md__26IPW",
    "row-direction-column-md": "row-direction-column-md__1DVK9",
    "rowDirectionColumnMd": "row-direction-column-md__1DVK9",
    "row-between-md": "row-between-md__2lYtW",
    "rowBetweenMd": "row-between-md__2lYtW",
    "row-around-md": "row-around-md__2Da3R",
    "rowAroundMd": "row-around-md__2Da3R",
    "row-start-md": "row-start-md__2ETE9",
    "rowStartMd": "row-start-md__2ETE9",
    "row-center-md": "row-center-md__2Q_RX",
    "rowCenterMd": "row-center-md__2Q_RX",
    "row-text-center-md": "row-text-center-md__3Niyg",
    "rowTextCenterMd": "row-text-center-md__3Niyg",
    "row-end-md": "row-end-md__1R77e",
    "rowEndMd": "row-end-md__1R77e",
    "row-top-md": "row-top-md__TS2N9",
    "rowTopMd": "row-top-md__TS2N9",
    "row-middle-md": "row-middle-md__20DIB",
    "rowMiddleMd": "row-middle-md__20DIB",
    "row-bottom-md": "row-bottom-md__rvXF7",
    "rowBottomMd": "row-bottom-md__rvXF7",
    "row-stretch-md": "row-stretch-md__n-zDe",
    "rowStretchMd": "row-stretch-md__n-zDe",
    "row-direction-row-lg": "row-direction-row-lg__2-agV",
    "rowDirectionRowLg": "row-direction-row-lg__2-agV",
    "row-direction-column-lg": "row-direction-column-lg__IWbOW",
    "rowDirectionColumnLg": "row-direction-column-lg__IWbOW",
    "row-between-lg": "row-between-lg__1Yhrh",
    "rowBetweenLg": "row-between-lg__1Yhrh",
    "row-around-lg": "row-around-lg__3Ms6x",
    "rowAroundLg": "row-around-lg__3Ms6x",
    "row-start-lg": "row-start-lg__PBW8D",
    "rowStartLg": "row-start-lg__PBW8D",
    "row-center-lg": "row-center-lg__1VKr1",
    "rowCenterLg": "row-center-lg__1VKr1",
    "row-text-center-lg": "row-text-center-lg__3ua46",
    "rowTextCenterLg": "row-text-center-lg__3ua46",
    "row-end-lg": "row-end-lg__3rIOv",
    "rowEndLg": "row-end-lg__3rIOv",
    "row-top-lg": "row-top-lg__38DWI",
    "rowTopLg": "row-top-lg__38DWI",
    "row-middle-lg": "row-middle-lg__1-qhu",
    "rowMiddleLg": "row-middle-lg__1-qhu",
    "row-bottom-lg": "row-bottom-lg__2uOr2",
    "rowBottomLg": "row-bottom-lg__2uOr2",
    "row-stretch-lg": "row-stretch-lg__1EsRY",
    "rowStretchLg": "row-stretch-lg__1EsRY",
    "row-direction-row-xl": "row-direction-row-xl__tun8T",
    "rowDirectionRowXl": "row-direction-row-xl__tun8T",
    "row-direction-column-xl": "row-direction-column-xl__26uYp",
    "rowDirectionColumnXl": "row-direction-column-xl__26uYp",
    "row-between-xl": "row-between-xl__2Lgm_",
    "rowBetweenXl": "row-between-xl__2Lgm_",
    "row-around-xl": "row-around-xl__ZmLji",
    "rowAroundXl": "row-around-xl__ZmLji",
    "row-start-xl": "row-start-xl__1nPme",
    "rowStartXl": "row-start-xl__1nPme",
    "row-center-xl": "row-center-xl__1p7Ki",
    "rowCenterXl": "row-center-xl__1p7Ki",
    "row-text-center-xl": "row-text-center-xl__1ZdxY",
    "rowTextCenterXl": "row-text-center-xl__1ZdxY",
    "row-end-xl": "row-end-xl__29ljH",
    "rowEndXl": "row-end-xl__29ljH",
    "row-top-xl": "row-top-xl__2L1Kz",
    "rowTopXl": "row-top-xl__2L1Kz",
    "row-middle-xl": "row-middle-xl__1qPrR",
    "rowMiddleXl": "row-middle-xl__1qPrR",
    "row-bottom-xl": "row-bottom-xl__2UVAa",
    "rowBottomXl": "row-bottom-xl__2UVAa",
    "row-stretch-xl": "row-stretch-xl__3KeLq",
    "rowStretchXl": "row-stretch-xl__3KeLq",
    "col-first": "col-first__1CYW8",
    "colFirst": "col-first__1CYW8",
    "col-last": "col-last__2ZBLn",
    "colLast": "col-last__2ZBLn",
    "col-shrink": "col-shrink__n5l0e",
    "colShrink": "col-shrink__n5l0e",
    "col-sm": "col-sm__3_GmT",
    "colSm": "col-sm__3_GmT",
    "col-first-sm": "col-first-sm__2DlYW",
    "colFirstSm": "col-first-sm__2DlYW",
    "col-last-sm": "col-last-sm__BiOVz",
    "colLastSm": "col-last-sm__BiOVz",
    "col-shrink-sm": "col-shrink-sm__34vCS",
    "colShrinkSm": "col-shrink-sm__34vCS",
    "col-md": "col-md__14N-g",
    "colMd": "col-md__14N-g",
    "col-first-md": "col-first-md__2BLKY",
    "colFirstMd": "col-first-md__2BLKY",
    "col-last-md": "col-last-md__1y--d",
    "colLastMd": "col-last-md__1y--d",
    "col-shrink-md": "col-shrink-md__35hQh",
    "colShrinkMd": "col-shrink-md__35hQh",
    "col-lg": "col-lg__11wY4",
    "colLg": "col-lg__11wY4",
    "col-first-lg": "col-first-lg__3Hopj",
    "colFirstLg": "col-first-lg__3Hopj",
    "col-last-lg": "col-last-lg__1K7Wq",
    "colLastLg": "col-last-lg__1K7Wq",
    "col-shrink-lg": "col-shrink-lg__1FXhI",
    "colShrinkLg": "col-shrink-lg__1FXhI",
    "col-xl": "col-xl__Xspgf",
    "colXl": "col-xl__Xspgf",
    "col-first-xl": "col-first-xl__2MBts",
    "colFirstXl": "col-first-xl__2MBts",
    "col-last-xl": "col-last-xl__2hpb_",
    "colLastXl": "col-last-xl__2hpb_",
    "col-shrink-xl": "col-shrink-xl__1NsLD",
    "colShrinkXl": "col-shrink-xl__1NsLD",
    "col-1": "col-1__3lJI7",
    "col1": "col-1__3lJI7",
    "col-2": "col-2__u5ZO3",
    "col2": "col-2__u5ZO3",
    "col-3": "col-3__2IQ_B",
    "col3": "col-3__2IQ_B",
    "col-4": "col-4__3OGtH",
    "col4": "col-4__3OGtH",
    "col-5": "col-5__3HJas",
    "col5": "col-5__3HJas",
    "col-6": "col-6__1ErBP",
    "col6": "col-6__1ErBP",
    "col-7": "col-7__3sCbi",
    "col7": "col-7__3sCbi",
    "col-8": "col-8__3dBWl",
    "col8": "col-8__3dBWl",
    "col-9": "col-9__1k1TN",
    "col9": "col-9__1k1TN",
    "col-10": "col-10__1abDg",
    "col10": "col-10__1abDg",
    "col-11": "col-11__3Nbki",
    "col11": "col-11__3Nbki",
    "col-12": "col-12__3M8_H",
    "col12": "col-12__3M8_H",
    "col-sm-1": "col-sm-1__3e_oj",
    "colSm1": "col-sm-1__3e_oj",
    "col-sm-2": "col-sm-2__18Yji",
    "colSm2": "col-sm-2__18Yji",
    "col-sm-3": "col-sm-3__2krET",
    "colSm3": "col-sm-3__2krET",
    "col-sm-4": "col-sm-4__20grp",
    "colSm4": "col-sm-4__20grp",
    "col-sm-5": "col-sm-5__33Clt",
    "colSm5": "col-sm-5__33Clt",
    "col-sm-6": "col-sm-6__2WHcU",
    "colSm6": "col-sm-6__2WHcU",
    "col-sm-7": "col-sm-7__j-Jo9",
    "colSm7": "col-sm-7__j-Jo9",
    "col-sm-8": "col-sm-8__oExCz",
    "colSm8": "col-sm-8__oExCz",
    "col-sm-9": "col-sm-9__34nFd",
    "colSm9": "col-sm-9__34nFd",
    "col-sm-10": "col-sm-10__98Fwm",
    "colSm10": "col-sm-10__98Fwm",
    "col-sm-11": "col-sm-11__2hHP6",
    "colSm11": "col-sm-11__2hHP6",
    "col-sm-12": "col-sm-12__6lsOv",
    "colSm12": "col-sm-12__6lsOv",
    "col-md-1": "col-md-1__3uBJX",
    "colMd1": "col-md-1__3uBJX",
    "col-md-2": "col-md-2__2F31G",
    "colMd2": "col-md-2__2F31G",
    "col-md-3": "col-md-3__IigRE",
    "colMd3": "col-md-3__IigRE",
    "col-md-4": "col-md-4__1G_3D",
    "colMd4": "col-md-4__1G_3D",
    "col-md-5": "col-md-5___mwK-",
    "colMd5": "col-md-5___mwK-",
    "col-md-6": "col-md-6__1nryj",
    "colMd6": "col-md-6__1nryj",
    "col-md-7": "col-md-7__4GuMH",
    "colMd7": "col-md-7__4GuMH",
    "col-md-8": "col-md-8__1DD56",
    "colMd8": "col-md-8__1DD56",
    "col-md-9": "col-md-9__DlSKO",
    "colMd9": "col-md-9__DlSKO",
    "col-md-10": "col-md-10__1tAnu",
    "colMd10": "col-md-10__1tAnu",
    "col-md-11": "col-md-11__1HIUu",
    "colMd11": "col-md-11__1HIUu",
    "col-md-12": "col-md-12__3HlTI",
    "colMd12": "col-md-12__3HlTI",
    "col-lg-1": "col-lg-1__3vlqN",
    "colLg1": "col-lg-1__3vlqN",
    "col-lg-2": "col-lg-2__2xf16",
    "colLg2": "col-lg-2__2xf16",
    "col-lg-3": "col-lg-3__jhk1f",
    "colLg3": "col-lg-3__jhk1f",
    "col-lg-4": "col-lg-4__1UUsr",
    "colLg4": "col-lg-4__1UUsr",
    "col-lg-5": "col-lg-5__3JWOS",
    "colLg5": "col-lg-5__3JWOS",
    "col-lg-6": "col-lg-6__1rj-9",
    "colLg6": "col-lg-6__1rj-9",
    "col-lg-7": "col-lg-7__3Jxce",
    "colLg7": "col-lg-7__3Jxce",
    "col-lg-8": "col-lg-8__2Vmy7",
    "colLg8": "col-lg-8__2Vmy7",
    "col-lg-9": "col-lg-9__29l8f",
    "colLg9": "col-lg-9__29l8f",
    "col-lg-10": "col-lg-10__3YXPX",
    "colLg10": "col-lg-10__3YXPX",
    "col-lg-11": "col-lg-11__vfFRI",
    "colLg11": "col-lg-11__vfFRI",
    "col-lg-12": "col-lg-12__1cWpK",
    "colLg12": "col-lg-12__1cWpK",
    "col-xl-1": "col-xl-1__1k2Hj",
    "colXl1": "col-xl-1__1k2Hj",
    "col-xl-2": "col-xl-2__HCpwK",
    "colXl2": "col-xl-2__HCpwK",
    "col-xl-3": "col-xl-3__2I5rl",
    "colXl3": "col-xl-3__2I5rl",
    "col-xl-4": "col-xl-4__1kN-C",
    "colXl4": "col-xl-4__1kN-C",
    "col-xl-5": "col-xl-5__wrpM-",
    "colXl5": "col-xl-5__wrpM-",
    "col-xl-6": "col-xl-6__GgUFT",
    "colXl6": "col-xl-6__GgUFT",
    "col-xl-7": "col-xl-7__WKopW",
    "colXl7": "col-xl-7__WKopW",
    "col-xl-8": "col-xl-8__2HpKP",
    "colXl8": "col-xl-8__2HpKP",
    "col-xl-9": "col-xl-9__2toyr",
    "colXl9": "col-xl-9__2toyr",
    "col-xl-10": "col-xl-10__2UpMy",
    "colXl10": "col-xl-10__2UpMy",
    "col-xl-11": "col-xl-11__1LOSF",
    "colXl11": "col-xl-11__1LOSF",
    "col-xl-12": "col-xl-12__YDjFe",
    "colXl12": "col-xl-12__YDjFe",
    "divider": "divider__11a8I",
    "divider-none": "divider-none__1bzsm",
    "dividerNone": "divider-none__1bzsm",
    "divider-extra-small": "divider-extra-small__voZ5G",
    "dividerExtraSmall": "divider-extra-small__voZ5G",
    "divider-small": "divider-small__3lduW",
    "dividerSmall": "divider-small__3lduW",
    "divider-medium": "divider-medium__HjYd_",
    "dividerMedium": "divider-medium__HjYd_",
    "divider-large": "divider-large__4WNoI",
    "dividerLarge": "divider-large__4WNoI",
    "divider-extra-large": "divider-extra-large__3OLo9",
    "dividerExtraLarge": "divider-extra-large__3OLo9",
    "divider-sm-none": "divider-sm-none__1WKVY",
    "dividerSmNone": "divider-sm-none__1WKVY",
    "divider-sm-extra-small": "divider-sm-extra-small__3vGqk",
    "dividerSmExtraSmall": "divider-sm-extra-small__3vGqk",
    "divider-sm-small": "divider-sm-small__jIm5H",
    "dividerSmSmall": "divider-sm-small__jIm5H",
    "divider-sm-medium": "divider-sm-medium__2zzUh",
    "dividerSmMedium": "divider-sm-medium__2zzUh",
    "divider-sm-large": "divider-sm-large__1enlu",
    "dividerSmLarge": "divider-sm-large__1enlu",
    "divider-sm-extra-large": "divider-sm-extra-large__pGHO1",
    "dividerSmExtraLarge": "divider-sm-extra-large__pGHO1",
    "divider-md-none": "divider-md-none__7XS7P",
    "dividerMdNone": "divider-md-none__7XS7P",
    "divider-md-extra-small": "divider-md-extra-small__2dryx",
    "dividerMdExtraSmall": "divider-md-extra-small__2dryx",
    "divider-md-small": "divider-md-small__3mFsK",
    "dividerMdSmall": "divider-md-small__3mFsK",
    "divider-md-medium": "divider-md-medium__1ctq8",
    "dividerMdMedium": "divider-md-medium__1ctq8",
    "divider-md-large": "divider-md-large__2gWut",
    "dividerMdLarge": "divider-md-large__2gWut",
    "divider-md-extra-large": "divider-md-extra-large__11Liq",
    "dividerMdExtraLarge": "divider-md-extra-large__11Liq",
    "divider-lg-none": "divider-lg-none__10f48",
    "dividerLgNone": "divider-lg-none__10f48",
    "divider-lg-extra-small": "divider-lg-extra-small__1bm-d",
    "dividerLgExtraSmall": "divider-lg-extra-small__1bm-d",
    "divider-lg-small": "divider-lg-small__bbaIS",
    "dividerLgSmall": "divider-lg-small__bbaIS",
    "divider-lg-medium": "divider-lg-medium__22z8y",
    "dividerLgMedium": "divider-lg-medium__22z8y",
    "divider-lg-large": "divider-lg-large__2vuca",
    "dividerLgLarge": "divider-lg-large__2vuca",
    "divider-lg-extra-large": "divider-lg-extra-large__1er3w",
    "dividerLgExtraLarge": "divider-lg-extra-large__1er3w",
    "divider-xl-none": "divider-xl-none__27Jmb",
    "dividerXlNone": "divider-xl-none__27Jmb",
    "divider-xl-extra-small": "divider-xl-extra-small__2_Gs7",
    "dividerXlExtraSmall": "divider-xl-extra-small__2_Gs7",
    "divider-xl-small": "divider-xl-small__afGtv",
    "dividerXlSmall": "divider-xl-small__afGtv",
    "divider-xl-medium": "divider-xl-medium__2rlII",
    "dividerXlMedium": "divider-xl-medium__2rlII",
    "divider-xl-large": "divider-xl-large__3N-xx",
    "dividerXlLarge": "divider-xl-large__3N-xx",
    "divider-xl-extra-large": "divider-xl-extra-large__11Yew",
    "dividerXlExtraLarge": "divider-xl-extra-large__11Yew",
    "fadeIn": "fadeIn__3wRxx",
    "pulse": "pulse__2ittt",
    "slideInDown": "slideInDown__3ThFM"
  };
  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.pascalCase = exports.camelCase = exports.capitalise = void 0; // capitalised the first letter of a sentence, useful for Formik form errors

  exports.capitalise = function (str) {
    return "" + str.charAt(0).toUpperCase() + str.slice(1);
  };

  exports.camelCase = function (str) {
    return str.replace(/-([a-z])/g, function (g) {
      return g[1].toUpperCase();
    });
  };

  exports.pascalCase = function (str) {
    return str.replace(/(^\w|-\w)/g, function (g) {
      return g.replace(/-/, '').toUpperCase();
    });
  };
  /***/

},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // import { MyComponent } from './Bottle';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Divider = exports.Col = exports.Row = exports.Grid = exports.Card = void 0;

  var Card_1 = __webpack_require__(4);

  Object.defineProperty(exports, "Card", {
    enumerable: true,
    get: function get() {
      return Card_1.Card;
    }
  });

  var Grid_1 = __webpack_require__(7);

  Object.defineProperty(exports, "Grid", {
    enumerable: true,
    get: function get() {
      return Grid_1.Grid;
    }
  });
  Object.defineProperty(exports, "Row", {
    enumerable: true,
    get: function get() {
      return Grid_1.Row;
    }
  });
  Object.defineProperty(exports, "Col", {
    enumerable: true,
    get: function get() {
      return Grid_1.Col;
    }
  });
  Object.defineProperty(exports, "Divider", {
    enumerable: true,
    get: function get() {
      return Grid_1.Divider;
    }
  });
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __importDefault = this && this.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Card = void 0;

  var react_1 = __importDefault(__webpack_require__(0));

  var styles_module_scss_1 = __importDefault(__webpack_require__(5));

  var theming_1 = __webpack_require__(6);

  var Card = function Card(_a) {
    var _b, _c;

    var title = _a.title,
        paragraph = _a.paragraph;
    var theme = theming_1.useTheme();
    console.log({
      theme: theme
    });
    return react_1.default.createElement("div", {
      className: styles_module_scss_1.default.main,
      style: {
        color: theme === null || theme === void 0 ? void 0 : theme.textColor,
        background: (_b = theme === null || theme === void 0 ? void 0 : theme.cardBackground) !== null && _b !== void 0 ? _b : "blue",
        border: (_c = theme === null || theme === void 0 ? void 0 : theme.cardBorder) !== null && _c !== void 0 ? _c : "5px solid red"
      }
    }, react_1.default.createElement("h2", {
      style: {
        color: theme === null || theme === void 0 ? void 0 : theme.textColor,
        fontFamily: theme === null || theme === void 0 ? void 0 : theme.fontPrimary
      }
    }, title), react_1.default.createElement("p", {
      style: {
        color: theme === null || theme === void 0 ? void 0 : theme.textColor,
        fontFamily: theme === null || theme === void 0 ? void 0 : theme.fontSecondary
      }
    }, paragraph, react_1.default.createElement("hr", null), react_1.default.createElement("b", null, "Card Colour: ", theme === null || theme === void 0 ? void 0 : theme.cardBackground)));
  };

  exports.Card = Card;
  /***/
},
/* 5 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__); // extracted by mini-css-extract-plugin

  /* harmony default export */


  __webpack_exports__["default"] = {
    "main": "main__3Y82J"
  };
  /***/
},
/* 6 */

/***/
function (module, exports) {
  module.exports = require("theming");
  /***/
},
/* 7 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __importDefault = this && this.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Divider = exports.Row = exports.Grid = exports.Col = void 0;

  var Col_1 = __webpack_require__(8);

  Object.defineProperty(exports, "Col", {
    enumerable: true,
    get: function get() {
      return __importDefault(Col_1).default;
    }
  });

  var Grid_1 = __webpack_require__(9);

  Object.defineProperty(exports, "Grid", {
    enumerable: true,
    get: function get() {
      return __importDefault(Grid_1).default;
    }
  });

  var Row_1 = __webpack_require__(10);

  Object.defineProperty(exports, "Row", {
    enumerable: true,
    get: function get() {
      return __importDefault(Row_1).default;
    }
  });

  var Divider_1 = __webpack_require__(11);

  Object.defineProperty(exports, "Divider", {
    enumerable: true,
    get: function get() {
      return __importDefault(Divider_1).default;
    }
  });
  /***/
},
/* 8 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __spreadArrays = this && this.__spreadArrays || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
      s += arguments[i].length;
    }

    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
        r[k] = a[j];
      }
    }

    return r;
  };

  var __importDefault = this && this.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var react_1 = __importDefault(__webpack_require__(0));

  var _helpers_1 = __webpack_require__(2);

  var styles_module_scss_1 = __importDefault(__webpack_require__(1));

  var Col = function Col(_a) {
    var children = _a.children,
        xs = _a.xs,
        sm = _a.sm,
        md = _a.md,
        lg = _a.lg,
        xl = _a.xl,
        first = _a.first,
        last = _a.last,
        shrink = _a.shrink,
        style = _a.style;
    var classNames = [{
      name: 'xs',
      size: xs
    }, {
      name: 'sm',
      size: sm
    }, {
      name: 'md',
      size: md
    }, {
      name: 'lg',
      size: lg
    }, {
      name: 'xl',
      size: xl
    }].reduce(function (acc, _a) {
      var size = _a.size,
          name = _a.name;
      return __spreadArrays(acc, [typeof size === 'number' && size >= 1 && size <= 12 ? name === 'xs' ? styles_module_scss_1.default["col" + size] : styles_module_scss_1.default["col" + _helpers_1.capitalise(name) + size] : typeof size === 'boolean' && name !== 'xs' ? styles_module_scss_1.default["col" + _helpers_1.capitalise(name)] : '', first === name ? first === 'xs' ? styles_module_scss_1.default.colFirst : styles_module_scss_1.default["colFirst" + _helpers_1.capitalise(name)] : '', last === name ? last === 'xs' ? styles_module_scss_1.default.colLast : styles_module_scss_1.default["colLast" + _helpers_1.capitalise(name)] : '', shrink === name ? shrink === 'xs' ? styles_module_scss_1.default.colShrink : styles_module_scss_1.default["colShrink" + _helpers_1.capitalise(name)] : '']);
    }, []).join(' ');
    return react_1.default.createElement("div", {
      className: styles_module_scss_1.default.col + " " + classNames,
      style: style
    }, children);
  };

  exports.default = Col;
  /***/
},
/* 9 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __importDefault = this && this.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var react_1 = __importDefault(__webpack_require__(0));

  var styles_module_scss_1 = __importDefault(__webpack_require__(1));
  /**
   Daintree’s grid system uses a series of containers, rows, and columns to layout and align content. It’s built with [flexbox](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Basic_Concepts_of_Flexbox) and is fully responsive. Below is an example and an in-depth look at how the grid comes together.
   New to or unfamiliar with flexbox? Read this [CSS Tricks](https://css-tricks.com/snippets/css/a-guide-to-flexbox/#flexbox-background) flexbox guide for background, terminology, guidelines, and code snippets.
  
   ---
  
   ### Grid
  
   A `<Grid/>` component is a container sets a width of 1260px (on XL) devices, and is 100% max-width throughout with even horizontal
  
   Our grid system is built on [react flexbox grid](https://github.com/roylee0704/react-flexbox-grid). It uses a **12 column** layout system
  
   Add prop `fluid` to remove fixed width
  
   ### Row
  
   Row creates a flex row between that allows wrapping of flex children (Cols), therefore allowing you to group columns
   together.
  
   Rows have gutters to allow correct spacing in Cols.
  
   #### Flex properties
   A row can be configured like any flex element to have special flex property alterations,
   these alterations can be configured responsively using the special breakpoint names:
  
    Using one of the flex property names below this list, you can enter the value as one of these breakpoint types
   declared below:
   - `xs` used on devices from 0px and above.
   - `sm` used on devices from 576px and above.
   - `md` used on devices from 768px and above.
   - `lg` used on devices from 992px and above.
   - `xl` used on devices from 1200px and above.
  
   - `between` \- adds `justify-content: space-between;`
   - `around` \- adds `justify-content: space-around;`
   - `start` \- adds `justify-content: flex-start;`
   - `center` \- adds `justify-content: center;`
   - `end` \- adds `justify-content: flex-end;`
   - `top` \- adds `align-items: flex-start;`
   - `middle` \- adds `align-items: center;`
   - `bottom` \- adds `align-items: flex-end;`
   - `stretch` \- adds `align-items: stretch;`
  
   Example:
   `<Row between="md" center="xs">...</Row>`
  
   ### No gutters
   Rows by default have gutters enabled, you can turn these off by setting the `gutters` prop to false.
  
   Example:
   `<Row gutters={false}>...</Row>
  
   A `<Row/>` component must only include `<Col/>` components. Children can then be placed inside of columns.
  
   ### Col
  
   Every Column must either have a declared number 1-12 as a reference to the 12-column grid system, or a boolean that will
   be set by default to share the space on the row (using flex-grow: 1), this means if you don't declare a number, or
   instead set a true boolean, the column will share the space in the row.
  
   Grid column widths:
  
   - 1 \- `8.3333333333%`
   - 2 \- `16.6666666667%`
   - 3 \- `25%`
   - 4 \- `33.3333333333%`
   - 5 \- `41.6666666667%`
   - 6 \- `50%`
   - 7 \- `58.3333333333%`
   - 8 \- `66.6666666667%`
   - 9 \- `75%`
   - 10 \- `83.3333333333%`
   - 11 \- `91.6666666667%`
   - 12 \- `100%`
  
   Pass a breakpoint type with a number 1-12 as a reference to the 12-column grid system
   - `xs` used on devices from 0px and above.
   - `sm` used on devices from 576px and above.
   - `md` used on devices from 768px and above.
   - `lg` used on devices from 992px and above.
   - `xl` used on devices from 1200px and above.
  
   `<Col/>` components must be placed inside of a `<Row/>` component.
  
   If you write multiple columns that total more than 100% width overall, then the overlapping columns will wrap onto a new row.
  
   #### Flex properties
   A row can be configured like any flex child element to have special flex property alterations,
   these alterations can be configured responsively using the special breakpoint names:
  
   Using one of the flex property names below this list, you can enter the value as one of these breakpoint types
   declared below:
   - `xs` used on devices from 0px and above.
   - `sm` used on devices from 576px and above.
   - `md` used on devices from 768px and above.
   - `lg` used on devices from 992px and above.
   - `xl` used on devices from 1200px and above.
  
   - `first` \- adds `order: -1;`
   - `last` \- adds `order: 1;`
  
   There is also a responsive shrink property that allows a column to ignore the growing behaviour and instead only
   take the width of its own children width, this is great use for pushing elements around such as aligning content
   to the right instead of using custom flex styling or floating.
  
   - `shrink` \- adds `flex: 0 1 auto`
  
   ### Divider
  
   Dividers manage spacing between rows and other content, it can be placed anywhere in the project and has fixed and
   responsive sizes.
  
   A divider supports 6 margin-bottom sizes:
   - `0` none
   - `1` extra small
   - `2` small
   - `3` medium (default)
   - `4` large
   - `5` extra large
  
   Dividers support either responsive or fixed variation, to use a fixed variation simply specify no props to use the
   default `3` margin spacing, or pass `margin` as a prop. To use responsive spacing you must prefix the prop with a
   breakpoint type such as `mdMargin`.
  
   Pass `margin` prefixed by a breakpoint type with a number 0-5 as a reference to the 6 margin sizes available
   - `xs` used on devices from 0px and above.
   - `sm` used on devices from 576px and above.
   - `md` used on devices from 768px and above.
   - `lg` used on devices from 992px and above.
   - `xl` used on devices from 1200px and above.
  
    Example:
   No margin in xs, small margin in sm, large margin in md
   `<Divider xsMargin={0} smMargin={2} mdMargin="4" />`
  
   Using margin 4
   `<Divider margin={4} />`
  
   Using default margin 3
   `<Divider />`
  
   */


  var Grid = function Grid(_a) {
    var children = _a.children,
        fluid = _a.fluid,
        flush = _a.flush;
    return react_1.default.createElement("div", {
      className: styles_module_scss_1.default.grid + " " + (fluid ? styles_module_scss_1.default.gridFluid : '') + " " + (flush ? styles_module_scss_1.default.gridFlush : '')
    }, children);
  };

  exports.default = Grid;
  /***/
},
/* 10 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __spreadArrays = this && this.__spreadArrays || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
      s += arguments[i].length;
    }

    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
        r[k] = a[j];
      }
    }

    return r;
  };

  var __importDefault = this && this.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var react_1 = __importDefault(__webpack_require__(0));

  var _helpers_1 = __webpack_require__(2);

  var styles_module_scss_1 = __importDefault(__webpack_require__(1));

  var Row = function Row(_a) {
    var children = _a.children,
        column = _a.column,
        row = _a.row,
        between = _a.between,
        around = _a.around,
        start = _a.start,
        center = _a.center,
        textCenter = _a.textCenter,
        end = _a.end,
        top = _a.top,
        middle = _a.middle,
        bottom = _a.bottom,
        stretch = _a.stretch,
        _b = _a.gutters,
        gutters = _b === void 0 ? true : _b,
        style = _a.style;
    var classNames = ['xs', 'sm', 'md', 'lg', 'xl'].reduce(function (acc, b) {
      return __spreadArrays(acc, [row === b ? styles_module_scss_1.default["rowDirectionRow" + (b === 'xs' ? '' : _helpers_1.capitalise(b))] : '', column === b ? styles_module_scss_1.default["rowDirectionColumn" + (b === 'xs' ? '' : _helpers_1.capitalise(b))] : '', between === b ? styles_module_scss_1.default["rowBetween" + (b === 'xs' ? '' : _helpers_1.capitalise(b))] : '', around === b ? styles_module_scss_1.default["rowAround" + (b === 'xs' ? '' : _helpers_1.capitalise(b))] : '', start === b ? styles_module_scss_1.default["rowStart" + (b === 'xs' ? '' : _helpers_1.capitalise(b))] : '', center === b ? styles_module_scss_1.default["rowCenter" + (b === 'xs' ? '' : _helpers_1.capitalise(b))] : '', textCenter === b ? styles_module_scss_1.default["rowTextCenter" + (b === 'xs' ? '' : _helpers_1.capitalise(b))] : '', end === b ? styles_module_scss_1.default["rowEnd" + (b === 'xs' ? '' : _helpers_1.capitalise(b))] : '', top === b ? styles_module_scss_1.default["rowTop" + (b === 'xs' ? '' : _helpers_1.capitalise(b))] : '', middle === b ? styles_module_scss_1.default["rowMiddle" + (b === 'xs' ? '' : _helpers_1.capitalise(b))] : '', bottom === b ? styles_module_scss_1.default["rowBottom" + (b === 'xs' ? '' : _helpers_1.capitalise(b))] : '', stretch === b ? styles_module_scss_1.default["rowStretch" + (b === 'xs' ? '' : _helpers_1.capitalise(b))] : '']);
    }, []).join(' ');
    return react_1.default.createElement("div", {
      style: style,
      className: styles_module_scss_1.default.row + " " + (!gutters ? styles_module_scss_1.default.rowNoGutters : '') + " " + classNames
    }, children);
  };

  exports.default = Row;
  /***/
},
/* 11 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __spreadArrays = this && this.__spreadArrays || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
      s += arguments[i].length;
    }

    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
        r[k] = a[j];
      }
    }

    return r;
  };

  var __importDefault = this && this.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var react_1 = __importDefault(__webpack_require__(0));

  var styles_module_scss_1 = __importDefault(__webpack_require__(1));

  var index_1 = __webpack_require__(2); // Builds margin spacer (responsive)


  var Divider = function Divider(_a) {
    var margin = _a.margin,
        xsMargin = _a.xsMargin,
        smMargin = _a.smMargin,
        mdMargin = _a.mdMargin,
        lgMargin = _a.lgMargin,
        xlMargin = _a.xlMargin,
        children = _a.children;
    var classNames = [{
      name: 'xs',
      size: xsMargin
    }, {
      name: 'sm',
      size: smMargin
    }, {
      name: 'md',
      size: mdMargin
    }, {
      name: 'lg',
      size: lgMargin
    }, {
      name: 'xl',
      size: xlMargin
    }].reduce(function (acc, _a) {
      var size = _a.size,
          name = _a.name;
      return __spreadArrays(acc, [size === 0 ? styles_module_scss_1.default["divider" + (name === 'xs' ? '' : index_1.capitalise(name)) + "None"] : '', size === 1 ? styles_module_scss_1.default["divider" + (name === 'xs' ? '' : index_1.capitalise(name)) + "ExtraSmall"] : '', size === 2 ? styles_module_scss_1.default["divider" + (name === 'xs' ? '' : index_1.capitalise(name)) + "Small"] : '', size === 3 ? styles_module_scss_1.default["divider" + (name === 'xs' ? '' : index_1.capitalise(name)) + "Medium"] : '', size === 4 ? styles_module_scss_1.default["divider" + (name === 'xs' ? '' : index_1.capitalise(name)) + "Large"] : '', size === 5 ? styles_module_scss_1.default["divider" + (name === 'xs' ? '' : index_1.capitalise(name)) + "ExtraLarge"] : '']);
    }, []).concat([margin === 0 ? styles_module_scss_1.default.dividerNone : '', margin === 1 ? styles_module_scss_1.default.dividerExtraSmall : '', margin === 2 ? styles_module_scss_1.default.dividerSmall : '', margin === 3 || !margin && !xsMargin && !smMargin && !mdMargin && !lgMargin && !xlMargin ? styles_module_scss_1.default.dividerMedium : '', margin === 4 ? styles_module_scss_1.default.dividerLarge : '', margin === 5 ? styles_module_scss_1.default.dividerExtraLarge : '']).join(' ');
    return react_1.default.createElement("div", {
      className: styles_module_scss_1.default.divider + " " + classNames
    }, children);
  };

  exports.default = Divider;
  /***/
}
/******/
]));